import { CSSProperties } from "react";

export const containerGridStyles: CSSProperties = {
  display: "grid",
  gridColumn: "1 / -1",
  gridTemplateColumns: "subgrid",
};
